import React from 'react';

const SetupTextArea = ({
    placeHolder,
    name,
    type,
    allTimeValue,
    valueUpdate
  }) => {

      // placeholder text formate.
   const formateText = (text) => {
    const wordArray = text?.split(" ");
    const formatedWordArray = wordArray?.map((item) => {
      const [firstL, ...rest] = item;
      rest.unshift(firstL?.toUpperCase());
      return rest?.join("");
    });
    return formatedWordArray?.join(" ")
  };
    return (
        <div className="w-full">
        <label className="font-semibold" htmlFor={placeHolder}>
        {formateText(placeHolder)}
        </label>

        <textarea
       
        value={allTimeValue}
          required
          min={1}
          type={type}
          id={placeHolder}
          onChange={valueUpdate}
          name={name}
          className="w-full border border-stone-300 lg:py-2 pl-3 mt-1.5 min-h-[44px] outline-none rounded-xl bg-stone-50 focus:bg-white focus:border-orange-500 focus:ring-2 focus:ring-orange-500/15"
        />
      </div>
    );
};

export default SetupTextArea;